const DoctorDashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/components/dashboard/doctor/FeaturisedDoctorDashboard"
  );
const PatientDashboard = () =>
  import(
    /* webpackChunkName: "Dashboard" */ "@/components/dashboard/patient/FeaturisedPatientDashboard"
  );

import DoctorRoutes from "./Doctor";
import AlliedRoutes from "./Allied";
import PatientDashboardRoutes from "@/routes/dashboard/Patient";
import SettingsRoutes from "@/routes/dashboard/settings";
import eventsRoutes from "@/routes/dashboard/events";
export default [
  {
    path: "doctor",
    name: "dashboard.doctor",
    redirect: {
      name: "dashboard.doctor.root"
    },
    component: DoctorDashboard,
    children: DoctorRoutes
  },
  {
    path: "allied",
    name: "dashboard.allied",
    redirect: {
      name: "dashboard.allied.root"
    },
    component: DoctorDashboard,
    children: AlliedRoutes
  },
  {
    path: "patient",
    name: "dashboard.patient",
    redirect: {
      name: "dashboard.patient.root"
    },
    component: PatientDashboard,
    children: PatientDashboardRoutes
  },
  {
    path: "/settings",
    name: "settings",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import("@/components/dashSetting/FeaturisedSettingsDashboard"),
    children: SettingsRoutes
  },
  {
    path: "/EventsDashboard",
    name: "EventsDashboard",
    meta: {
      requiresAuth: false
    },
    component: () =>
      import("@/components/dashboard/cme/FeaturisedEventsDashboard"),
    children: eventsRoutes
  },
];
